import CrudRepository from './CrudRepository'

export default class ProfileDataRepository extends CrudRepository {
  constructor () {
    super('core/api/users/personalInfo')
  }
}
